module.exports = import("https://cdnjs.cloudflare.com/ajax/libs/p5.js/1.4.0/p5.min.js");;